import { getScreenProfile } from './getScreenProfile'
import { getWindowProfile } from './getWindowProfile'

export function getBrowserProfile() {
  return {
    cookies:
      typeof navigator.cookieEnabled !== 'undefined'
        ? navigator.cookieEnabled
        : false,
    codeName: navigator.appCodeName,
    description: getDocumentDescription(),
    language: navigator.language,
    name: navigator.appName,
    online: navigator.onLine,
    platform: navigator.platform,
    useragent: navigator.userAgent,
    version: navigator.appVersion,
    doNotTrack: navigator.doNotTrack,
    screen: getScreenProfile(),
    window: getWindowProfile(),
  }
}

function getDocumentDescription() {
  let el
  if (document && typeof document.querySelector === 'function') {
    el = document.querySelector('meta[name="description"]')
  }
  return el ? el.content : ''
}
